// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAGOHN54gyLZLP4rc2ki5ovT9yROTRgOFA",
  authDomain: "reservation-lasertag.firebaseapp.com",
  projectId: "reservation-lasertag",
  storageBucket: "reservation-lasertag.firebasestorage.app",
  messagingSenderId: "54083277673",
  appId: "1:54083277673:web:a0c8454230d0ba41e0a3f8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Export the database for use in other files
export { db };